var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.009765625,
    height: 32.0029296875,
    viewBox: "0 0 32.009765625 32.0029296875",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9172 0.585938C19.1359 -0.195312 17.8672 -0.195312 17.0859 0.585938L9.58594 8.08594C8.80469 8.86719 8.80469 10.1359 9.58594 10.9172L10.5859 11.9172C11.3672 12.6984 12.6359 12.6984 13.4172 11.9172L13.6672 11.6672L20.3422 18.3359L20.0922 18.5859C19.3109 19.3672 19.3109 20.6359 20.0922 21.4172L21.0922 22.4172C21.8734 23.1984 23.1422 23.1984 23.9234 22.4172L31.4234 14.9172C32.2047 14.1359 32.2047 12.8672 31.4234 12.0859L30.4234 11.0859C29.6422 10.3047 28.3734 10.3047 27.5922 11.0859L27.3422 11.3359L20.6672 4.66094L20.9172 4.41094C21.6984 3.62969 21.6984 2.36094 20.9172 1.57969L19.9172 0.579687L19.9172 0.585938ZM10.4172 18.5859C9.63594 17.8047 8.36719 17.8047 7.58594 18.5859L0.585938 25.5859C-0.195312 26.3672 -0.195312 27.6359 0.585938 28.4172L3.58594 31.4172C4.36719 32.1984 5.63594 32.1984 6.41719 31.4172L13.4172 24.4172C14.1984 23.6359 14.1984 22.3672 13.4172 21.5859L13.3297 21.4984L17.0047 17.8297L14.1734 14.9984L10.5047 18.6672L10.4172 18.5797L10.4172 18.5859Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003);
export default __webpack_public_path__ + "static/media/003.8111bdcaec84acc16af87136b0e503ea.svg";
export { ForwardRef as ReactComponent };